var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid w-100",staticStyle:{"min-height":"30rem"}},[_c('div',{staticClass:"card p-2",staticStyle:{"height":"calc(100dvh - 7rem)"}},[_c('VuePerfectScrollbar',{attrs:{"settings":{ suppressScrollX : false }}},[_c('staffShift',{staticClass:"w-100",attrs:{"isManagement":true}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }